<button    aria-label="login" (click)="onClick()" class="login-btn btn btn-primary" type="button">{{"common.login"|translate}}</button>